import { useEffect, useState, useContext } from 'react';
import axios from "axios";
import { getBaseUrl } from "../utils";
import { Link, useNavigate } from 'react-router-dom';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from './UserContext';

const Resume = () => {
    const { subscription } = useContext(UserContext);

    const navigate = useNavigate();
    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");
    const [OpenPopup, setOpenPopup] = useState(false);
    const handleButtonClick = () => {
        // Check if resume feature is enabled
        if (!subscription?.features?.resume_enabled) {
            toast.error("Your current subscription does not allow resume creation.");
            return;
        }

        // Check resume creation limit
        const resumeLimit = subscription?.features?.resume || 0;

        if (resumes.length >= resumeLimit) {
            toast.error("Your resume creation limit has been reached.");
            return;
        }
        
        setOpenPopup(!OpenPopup);
    }
    const Close__button = () => {
        setOpenPopup(false);
    };

    const [resumes, setResumes] = useState([]);

    useEffect(() => {
        fetchResumes();
    }, []);

    const fetchResumes = async () => {
        try {
            const response = await axios.get(`${baseUrl}user_api/listProfile?limit=10&page=1`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response.data.status) {
                setResumes(response.data.data);
                console.log("Resumes: ", response.data.data);
            }
        } catch (error) {
            console.error("Error fetching resumes:", error);
        }
    };
    function editResume(data) {
        if (data._id) {
            navigate(`/resume/resume-create?userProfileId=${data._id}`);
        }
    }
    const deleteResume = async (data) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this resume?");
        if (!isConfirmed) return;
        try {
            const resume_id = data._id; // Extracting resume ID

            const response = await axios.post(
                `${baseUrl}user_api/delete_resume_by_id`,
                { resume_id }, // Sending resume_id in the request body
                {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Add your token here
                        'Content-Type': 'application/json', // Use JSON format
                    },
                }
            );

            console.log("Delete Response:", response.data);

            if (response.status === 200) {
                fetchResumes();
                toast.success("Resume deleted successfully!");
            } else {
                toast.error(response.data.message || "Failed to delete resume.");
            }
        } catch (error) {
            toast.error("Error deleting resume.");
            console.error("Error in API call:", error);
        }
    };

    const downloadResume = async (filePath) => {
        try {
            const response = await fetch(filePath);

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "Resume.pdf"; // Force download with this filename
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading the file:", error);
        }
    };

    const shareResume = (item) => {
        if (navigator.share) {
            navigator.share({
                title: "Resume",
                text: "Check out this resume!",
                url: item.filePath
            }).catch((error) => console.log("Error sharing:", error));
        } else {
            alert("Sharing is not supported in this browser.");
        }
    };

    const viewResume = (item) => {
        window.open(item.filePath, "_blank");
    };

    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const handleTemplateClick = (templateNumber) => {
        setSelectedTemplate(templateNumber);
    };

    const click_on_template = () => {
        if (selectedTemplate !== null) {
            navigate(`/resume/resume-create?template=${selectedTemplate}`);
        } else {
            alert("Please select a template before proceeding.");
        }
    };

    return (
        <div>
            <ToastContainer />
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-7 Dashboard___section__new'>

                        {resumes.length > 0 ? (
                            resumes.map((items, index) => (
                                <div className="pl-0 pr-0 pb-4" key={index}>
                                    <h1 className="Header__text font-bold pb-2">{items.name}</h1>
                                    <div className='md:pr-4'>
                                        <div className='p-3 bg-white rounded-xl'>
                                            <div className='flex gap-2 items-center'>
                                                <img style={{ maxWidth: '20%', height: 'auto' }} src={items.profile_img || '/assates/Resume__images.png'} alt='images' />
                                                <div className='w-full'>
                                                    <div className='flex itmes-center pb-1 justify-between'>
                                                        <label className='Header__text font-bold' style={{ fontSize: '18px' }}>{items.name}</label>
                                                        <div className="p-0.5 pl-2 pr-2 rounded-md choose_qulifation_section cursor-pointer" onClick={() => { deleteResume(items) }} style={{ color: 'red' }}>
                                                            <i className="ri-delete-bin-fill"></i>
                                                        </div>
                                                    </div>
                                                    <p className='Paragraph__etxt'>{items.profileTagline}</p>
                                                    <div className='flex justify-between items-center pt-1'>
                                                        <div className='Paragraph__etxt'>
                                                            <i className="ri-phone-fill"></i>
                                                            <label>{items.number}</label>
                                                        </div>
                                                        <div className='Paragraph__etxt'>
                                                            <i className="ri-mail-fill"></i>
                                                            <label>{items.email}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <p>{items.filePath}</p> */}

                                            <div className='border-b mt-2' />
                                            <div className='mt-2 flex justify-between'>
                                                <div className='flex gap-3 Paragraph__etxt'>
                                                    <div className='flex items-center gap-1' style={{ color: '#AAC000' }} onClick={() => { editResume(items) }}>
                                                        <i className="ri-pencil-line"></i>
                                                        <label>Edit</label>
                                                    </div>

                                                    <div className='flex items-center gap-1' onClick={() => { downloadResume(items.filePath) }}>
                                                        <img src='/assates/dowanloadimages.svg' alt='images' />
                                                        <label>Download</label>
                                                    </div>

                                                    <div className='flex items-center gap-1' onClick={() => { shareResume(items) }}>
                                                        <i className="ri-share-fill"></i>
                                                        <label>Share</label>
                                                    </div>
                                                </div>
                                                <h1 className='cursor-pointer' onClick={() => { viewResume(items) }} >View Resume</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className='row h-full'>
                                <div className='col-12 flex flex-col justify-center items-center w-full h-[100vh]'>
                                    <i className="ri-sticky-note-add-fill text-[32px]"></i>
                                    <h5 className='Header__text font-medium' style={{ fontSize: '20px' }}>No Resume Found!</h5>
                                    <label onClick={handleButtonClick} className='Paragraph__etxt ' style={{ fontSize: '17px' }}>Click to create your first resume.</label>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='col-md-5 p-0 m-0'>
                        <h1 className='Header__text font-bold pb-2'>Available Templates</h1>
                        <div className="bg-white p-4 rounded-xl" onClick={handleButtonClick}>

                            <div className='flex gap-4'>
                                <div className=''>
                                    <img src='/assates/Resume_one.png' alt='images' />

                                </div>
                                <div className=''>
                                    <img src='/assates/resume__tow.png' alt='images' />

                                </div>
                            </div>
                            <div className='flex gap-4 pt-3'>
                                <div className=''>
                                    <img src='/assates/resume__three.png' alt='images' />

                                </div>
                                <div className=''>
                                    <img src='/assates/resume_four.png' alt='images' />

                                </div>
                            </div>
                        </div>
                    </div>






                    {/* Pupop section main */}
                    {OpenPopup && (
                        <div className="popup__Resume">
                            <div className="popup_Resume_choose">
                                <div className='header bg-black rounded-tl-lg rounded-tr-lg text-white p-3 relative '>
                                    <h6>Template</h6>
                                    <i className="ri-close-circle-line absolute top-4 text-[17px] right-3" onClick={Close__button}></i>
                                </div>
                                <div className='p-4'>
                                    <div className='flex gap-4'>
                                        <div
                                            className='p-2 rounded-lg'
                                            style={{ border: selectedTemplate === 1 ? '4px solid black' : '2px solid gray' }}
                                            onClick={() => handleTemplateClick(1)}
                                        >
                                            <img src='/assates/Resume_one.png' alt='images' style={{ height: '150px' }} />
                                            <h4 className='pt-1 Paragraph__etxt font-bold'>Template 1</h4>
                                        </div>

                                        <div
                                            className='p-2 rounded-lg'
                                            style={{ border: selectedTemplate === 2 ? '4px solid black' : '2px solid gray' }}
                                            onClick={() => handleTemplateClick(2)}
                                        >
                                            <img src='/assates/resume__tow.png' alt='images' style={{ height: '150px' }} />
                                            <h4 className='pt-1 Paragraph__etxt font-bold'>Template 2</h4>
                                        </div>
                                    </div>
                                    <div className='flex gap-4 pt-3'>
                                        <div
                                            className='p-2 rounded-lg'
                                            style={{ border: selectedTemplate === 3 ? '4px solid black' : '2px solid gray' }}
                                            onClick={() => handleTemplateClick(3)}
                                        >
                                            <img src='/assates/resume__three.png' alt='images' style={{ height: '150px' }} />
                                            <h4 className='pt-1 Paragraph__etxt font-bold'>Template 3</h4>
                                        </div>

                                        <div
                                            className='p-2 rounded-lg'
                                            style={{ border: selectedTemplate === 4 ? '4px solid black' : '2px solid gray' }}
                                            onClick={() => handleTemplateClick(4)}
                                        >
                                            <img src='/assates/resume_four.png' alt='images' style={{ height: '150px' }} />
                                            <h4 className='pt-1 Paragraph__etxt font-bold'>Template 4</h4>
                                        </div>
                                    </div>
                                    <button onClick={() => { click_on_template() }} className='bg-black w-full p-2 rounded-lg mt-3 text-white'>Next</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Resume;